export const TRIAL_PAGES_PROOF_ON_SCREEN = 'proof_on_screen';
